import { useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/urls';

const useEditPbwUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const editPbwUser = async (id, data) => {

    setLoading(true);
    setError(null);
    try {
      const response = await axios.put(`${BASE_URL}/pbw-meucupom-users/${id}`, data, {
        headers: {Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`}
      });
      return response.data;
      
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { editPbwUser, loading, error };
}

export default useEditPbwUser
